var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "New-Design-v1_02",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Moderation---List-View",
  transform: "translate(-1053.000000, -407.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Main-Container",
  transform: "translate(170.000000, 316.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(802.000000, 83.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M89.3333333,13.6666667 L89.3333333,7 L86.6666667,7 L86.6666667,13.6666667 L80,13.6666667 L80,16.3333333 L86.6666667,16.3333333 L86.6666667,23 L89.3333333,23 L89.3333333,16.3333333 L96,16.3333333 L96,13.6666667 L89.3333333,13.6666667 Z",
  id: "Cross",
  transform: "translate(88.000000, 15.000000) rotate(-45.000000) translate(-88.000000, -15.000000) "
})))))));
export { SvgClose as ReactComponent };
export default __webpack_public_path__ + "static/media/close.cf00a2de.svg";